module.exports = __webpack_public_path__ + "static/img/fingerpost_express_4.d5a6d6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_express_4.jpg
// module id = RXml
// module chunks = 0